export const regexCPF = /^(\d{3}.\d{3}.\d{3}-\d{2}|\d{11})$/;

export function validateCPF(value: string = '') {
  if (!value) return false;

  const isString = typeof value === 'string';
  if (isString && !regexCPF.test(value)) return false;

  const numbers = matchNumbers(value);
  if (numbers.length !== 11) return false;

  const items = [...new Set(numbers)];
  if (items.length === 1) return false;

  const base = numbers.slice(0, 9);
  const digits = numbers.slice(9);

  const calc0 = base.map((n, i) => baseCalc(n, i, numbers.length - 1)).reduce(sumCalc, 0);

  const digit0 = digitCalc(calc0, numbers);

  const calc1 = base
    .concat(digit0)
    .map((n, i) => baseCalc(n, i, numbers.length))
    .reduce(sumCalc, 0);

  const digit1 = digitCalc(calc1, numbers);

  return digit0 === digits[0] && digit1 === digits[1];
}

function baseCalc(n: number, i: number, x: number) {
  return n * (x - i);
}

function sumCalc(a: number, b: number) {
  return a + b;
}

function digitCalc(n: number, numbers: number[]) {
  const rest = n % numbers.length;
  return rest < 2 ? 0 : numbers.length - rest;
}

function matchNumbers(value: string | number | number[] = '') {
  const match = value.toString().match(/\d/g);
  return Array.isArray(match) ? match.map(Number) : [];
}
